import styled, { css } from 'styled-components';
import { layout } from '../../../../package.json';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  min-height: 400px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;

  span {
    font-size: 24px;

  }
`;

export const ContainerOrdersNoData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  span {
    font-size: 22px;
    margin-top: 16px;
    color: var(--primary);
  }

`;

export const AskAgainButton = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 13rem;
  cursor: pointer;
  border: 1px solid var(--primary);
  border-radius: 0.37rem;
  background-color: #3d733b;
  transition:all 0.6s ease;
  padding: 0.5rem;

  span {
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: left;
    text-transform: uppercase;
  }

  svg {
    color: var(--btn-finish);
  }

  :hover{
    background-color: var(--primary);
    svg {
      color: #FFF;
    }

    span {
      color: #FFF;
    }
  }
`;

export const ReviewOrderButton = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 13rem;
  height: unset;
  cursor: pointer;
  border-radius: 0.37rem;
  background-color: var(--primary);
  transition:all 0.6s ease;
  padding: 0.5rem;

  span {
    color: #ffffff;
    font-size: 0.91rem;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
  }

  svg {
    color: var(--btn-finish);
  }

  :hover{
    background-color: var(--primary);
    svg {
      color: #FFF;
    }

    span {
      color: #FFF;
    }
  }
`;

export const ContainerOrders = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  width: 100%;
`;

export const ContainerOrdersRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--primary);
  margin-bottom: 10px;
  background-color: #FFF;
`;

export const ContainerOrdersRowBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  margin-bottom: 1rem;
  gap: 1rem;
`;

export const ContainerOrdersRowLeft = styled.div`
  width: 100%;
  display: flex;
  flex-direction:column;
`;


export const ContainerOrdersRowRight = styled.div`
  width: 100%;
`;


export const ContainerOrdersRowFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  width: 100%;
  gap: 0.5rem;
`;

export const OrderNumber = styled.div`
  width: 100%;
  span{
    font-size: 1.75rem;
    font-weight: 900;
    color: var(--primary);
  }
`;

export const OrderAddresse = styled.div`
  width: 100%;
  margin: 0.5rem auto;

  span{
    font-size: 1rem;
    font-weight: 400;
  }
`;

export const OrderDataTimeAndAmout = styled.div`
  width: 100%;
  height: 30px;

  span{
    font-size: 0.81rem;
    font-weight: 200;
  }
  margin-bottom: 0.5rem;
`;

export const OrderStatus = styled.div`
  display: grid;
  max-width: 18.75rem;
  grid-template-areas:
    'title icon'
    'status icon';
  grid-template-columns: 1fr 0.3fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 5px;
`;

export const OrderStatusTitle = styled.div`
  grid-area: title;
  width: 100%;

  span{
    font-size: 1.18rem;
    font-weight: 800;
    color: var(--primary);
  }
`;

export const OrderStatusStatus = styled.div`
  grid-area: status;
  width: 100%;
  display: flex;

  background-color: #e6e2e2;
  padding: 0.62rem;
  border-radius: 0.5rem;

  span{
    margin: 0 auto;
    font-size: 1rem;
  }
`;

interface OrderStatusIconProps {
  type?:
  | 'pending'
  | 'pending_payment'
  | 'payment_approved'
  | 'processing'
  | 'available'
  | 'available_pickup'
  | 'completed'
  | 'sent'
  | 'in_transit'
  | 'canceled'
  | 'closed'
  | 'fraud';
}

export const OrderStatusIcon = styled.div<OrderStatusIconProps>`
  grid-area: icon;

  svg {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-color: #3aae36;

    ${props =>
    props.type === 'payment_approved' &&
    css`
        background-color: #3aae36;
      `}

    ${props =>
    props.type === 'pending' &&
    css`
        background-color: #e4e658;
      `}

    padding: 2px;
  }
`;

export const StyledPaginateContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  padding: 20px 0;

  .pagination {
    display: flex;
    width: 100%;
    max-width: 37rem;
    flex-wrap: wrap;
    gap: 1rem;

    li:first-child,
    li:last-child {
      max-width: 5rem;
    }

    li {
      width: 100%;
      max-width: 2.5rem;
      border: 1px solid var(--primary);
      background-color: #FFF;
      display: inline-flex;
      a {
        width: 100%;
        padding: 0.5rem;
        cursor: pointer;
        text-align: center;
      }
    }
    color: var(--primary);

    @media (max-width: ${layout.tablet}) {
      width: 80%;
    }
  }
  .break-me {
    cursor: default;
  }
  .active {
    border-color: transparent !important;
    background-color: var(--primary) !important;
    color: #FFF;
  }

  .disabled {
    display:none;
  }
`;
